import React, { useContext, useState, useEffect } from 'react';
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import axios from 'axios';
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image'
import LykioButton from '../common/LykioButton';
import Modal from 'react-bootstrap/Modal';
import AccessAlarmSharpIcon from '@mui/icons-material/AccessAlarmSharp';

import {
	AUTHORIZED_URL_PREFIX,
	AxiosConfig,
    GUIDES_URL
} from '../../Utils/Constants';

function Welcome() {
    const context = useContext(LykioContext);
    const userRole = localStorage.getItem('userRole');
    const tenantProperties = context.tenantProperties;
	const storiesName = tenantProperties && tenantProperties.storiesName ? tenantProperties.storiesName : "Stories";
    const tenantName = tenantProperties && tenantProperties.name ? tenantProperties.name : "Lykio";
    const categoriesName = tenantProperties && tenantProperties.categoriesName ? tenantProperties.categoriesName : "Categories";
    const initiative = (tenantProperties && tenantProperties.initiative) && tenantProperties.initiative;
    const welcomeMessage = (tenantProperties && tenantProperties.welcomeMessage) && tenantProperties.welcomeMessage;
    const showGuides =  tenantProperties && tenantProperties.showGuides;
    const guidesS3Url =  (tenantProperties && tenantProperties.guidesS3Url) ? tenantProperties.guidesS3Url : undefined;
    const showManagerInduction =  tenantProperties && tenantProperties.showManagerInduction;
    const managerInductionS3Url =  (tenantProperties && tenantProperties.managerInductionS3Url) ? tenantProperties.managerInductionS3Url : undefined;
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

	const [ isLoading, setIsLoading ] = useState(true);
    const [enableSchools, setEnableSchools] = useState(false);

	useEffect(() => {
		const fetchGuidesData = async () => {
			try {
				const { data } = await axios.get(`${AUTHORIZED_URL_PREFIX}${GUIDES_URL}`, AxiosConfig());
				setEnableSchools(data.enableSchools);
				setIsLoading(false);
				if (!data.success) {
					notify(pleaseRefreshError);
				}
			} catch (error) {
				console.log(error);
				notify(pleaseRefreshError);
			}
		};
		fetchGuidesData();
	}, []);


    return ( <div className="lykioccs-main-content" style={{backgroundColor:'white'}}>
        {isLoading ? (
				<Loading />
			) : 
        <Container>
            {enableSchools ? 
            <Row>
                <Tabs defaultActiveKey="content" id="uncontrolled-tab-example" className="mb-3">
                    <Tab eventKey="content" title="Accessing My Content">
                        <p>
                        Your purchased content is categorized into two tabs, <b>“My Interactive Books”</b> and <b>“My Resources”</b>.
                        </p>
                        <p>
                        “My Interactive Books” holds all purchased levels for Workbooks, Teacherbooks and Studentbooks.
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/books.png'/><br/><br/>
                        <p>
                        “My Resources” holds all complimentary resources for your purchased levels. These resources include video and audio files, flashcards as well as complimentary pdf files(posters, maps etc.).
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/resources.png'/><br/><br/>
                        <p>
                        Under the resources page you will also find download links for the <b>Time Traveller Game</b> for Windows, Mac and Android devices.
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/client_downloads.png'/><br/><br/>
                    </Tab>
                    <Tab eventKey="connect" title="Connect">
                    {(userRole==='teacher' || userRole==='admin') && 
                    <Container>
                        <p>
                        Upon registration under the <b><a href="/connections" target="_blank" rel="noopener noreferrer">Connect</a></b> page you will find two options.
                        </p>
                        <p>
                        You can either enrol to a school, if your school administrator has shared with you the school id (a unique identifier for the school) or you can create your own school.  
                        </p>
                        <p>
                        To create your own school all you have to do is provide a name and the system will make you this school’s administrator and generate a <b>school id</b> which you can share with your fellow teachers in order for them to enrol to your newly created school.
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/admin_connect.png'/><br/><br/>
                        <p>
                        From this page you will be able to create classes (only after you have successfully completed one of the two aforementioned options). Each class you create will come with an auto-generated <b>class reference</b>. This reference can be shared with your students so that they can enrol to it and consequently to your school.
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/classes.png'/><br/><br/>
                    </Container>
                    }
                    {(userRole==='user') &&
                        <Container>
                        <p>
                        As a student you can use the <b><a href="/connections" target="_blank" rel="noopener noreferrer">Connect</a></b> page to enrol to a class by using the <b>class reference</b> shared to you by your teacher.
                        </p>
                        <p>
                        You can also use this page after you have already enrolled to a class to change it (due to special circumstances or the possible end of the school year).  
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/student_class.png'/><br/><br/>
                        </Container>
                    }
                    </Tab>
                    {(userRole==='teacher' || userRole==='admin') &&
                    <Tab eventKey="usermgmt" title="User Management">
                        {(userRole==='admin') &&
                        <Container>
                        <p>
                        As a school administrator you can use the <b><a href="/school-user-management" target="_blank" rel="noopener noreferrer">User Management</a></b> page to manage all users enrolled to all of your school's classes (both theachers and students).                        
                        </p>
                        <p>
                        For every user you can view their email, signup date, role and current status. You can edit their details as well as lock and activate them as you see fit.
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/user_mgmt.png'/><br/><br/>
                        </Container>
                        }
                        {(userRole==='teacher') &&
                        <Container>
                        <p>
                        As a teacher you can use the <b><a href="/school-user-management" target="_blank" rel="noopener noreferrer">User Management</a></b> page to view the students enrolled to all classes created by you.                        
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/teacher_user_mgmt.png'/><br/><br/>
                        <p>
                        For every student you can view their email, signup date, role and current status.
                        </p>
                        </Container>
                        }
                    </Tab>
                    }
                    {(userRole==='teacher' || userRole==='admin') &&
                    <Tab eventKey="reporting" title="Reporting">
                        <p>
                        In the Reporting page you can view all of your classes and their performance for their current Workbook and their detailed score for the Time Traveller Game.
                       </p>
                       <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/reporting.png'/><br/><br/>
                    </Tab>
                    }
                    <Tab eventKey="profile" title="Profile and Settings">
                        <Container>
                            <p>
                            By clicking on the avatar at the right side of the navigation bar you can access your <b><a href="/school-user-management" target="_blank" rel="noopener noreferrer">Profile</a></b> page.
                            </p>
                            <p>
                            By clicking on the <b>Edit</b> buton from the left element of the screen you can change your profile picture and add any amount of personal information you want to your profile.
                            </p>
                            <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/profile_update.png'/><br/><br/>
                            <p>
                            On this page you will also find a list of all <b>active access codes</b> you own with details about the product they unlock, the date you activated them and their total duration.
                            </p>
                            <p>
                            You can always add more access codes from products you have bought by entering them in the form located below your access codes.
                            </p>
                            <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/TT/Guides/access_codes.png'/><br/><br/>
                            <p>    
                            In case you ever need to change your password or the frequency with which you receive emails from the platform you can access the <b><a href="/settings" target="_blank" rel="noopener noreferrer">Settings</a></b> page.
                            </p>
                        </Container>
                    </Tab>
                </Tabs>
            </Row> 
            :
            <Row>
            <Tabs defaultActiveKey="welcome" id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="welcome" title="Welcome">
            <Container>
                    <Row className='lykiocss-margin-top-1em'>
                       <div className='lykiocss-title-light'>{`Welcome to Lykio for  ${initiative ? initiative : tenantName}`}</div>
                       <p className='lykiocss-margin-top-1em'>{welcomeMessage!=='undefined' && welcomeMessage}</p>
                    </Row>
                    <Row className='lykiocss-margin-top-1em'>
                        <p>Use this page as a user guide to navigating through Lykio's features. Learn how to find content, add your own, find out what your colleagues are up to and much more.</p>
                        <p><strong>The objective</strong></p>
                        <p>Our goal is to help employees in staying engaged and be productive in a remote/hybrid working model!</p>
                        <p>This will be achieved by increasing the digital and e-leadership skills of VET trainers dealing with such employees as well as corporate trainers.</p>
                        <p>To that end, our team is developing:<br /><br />
                            <ul>
                                <li>a full training course for the digital upskilling of corporate and VET trainers</li>
                                <li>a highly engaging digital tool - the Experience Brewing Enging - to be used by trainers and employees</li>
                                <li>a virtual community acting as an international network of project enthusiasts</li>
                            </ul>
                        </p>
                        
                    </Row>
                    {(showManagerInduction && managerInductionS3Url.length>10 && ((userRole==='teacher') || userRole==='manager' || (userRole==='admin'))) && 
                    <Row>
                        <Col style={{marginRight: '3rem'}} xxl={2}>
                            <LykioButton style={{marginBottom: '0.3rem'}} onClick={handleShow} className="lykiocss-form-button">Facilitate Energizing Briefing Sessions</LykioButton>
                        </Col>
                        <Col xl={7} lg={10} xs={12}>
                            <p style={{marginBottom: '0.3rem'}}>This module helps Viceroy Managers to facilitate energizing briefing sessions by giving tips and pointers on conducting exceptional briefing sessions, in this way maximizing the impact of the Our Ideology Toolkit platform in the continuous effort of embedding the Viceroy culture in Viceroy teams and colleagues.</p>
                            <p><AccessAlarmSharpIcon/>&nbsp;40 minutes</p>
                        </Col>
                        <Modal show={show} onHide={handleClose} fullscreen>
                            <Modal.Header closeButton>
                            </Modal.Header>
                            <Modal.Body style={{padding:'0em!important'}}>
                            <div className="lykiocss-guides-iframe">
                                <iframe src={managerInductionS3Url} />
                            </div>
                            </Modal.Body>
                        </Modal>
                    </Row>
                    }
                    {(showGuides && guidesS3Url.length>10) &&
                    <div className="lykiocss-guides-iframe lykiocss-margin-top-2em">
                        <iframe src={guidesS3Url} />
                    </div>
                    }
                </Container>
            </Tab>
            <Tab eventKey="home" title="Home page">
                <Container>
                    <Row>
                        <Col xs={6}>
                            <div className='lykiocss-title-light'>Home page</div>
                            <p>When you log into the platform, your <b><a href="/" target="_blank" rel="noopener noreferrer">Home page</a></b> will include widgets to inform you on your progress, your achievements and the status of the platform. </p>
                            <p>On your home screen widget, you will be able to view your level, the login streak bar, your XP(Experience Points) and Impact Index. Your Impact Index is calculated based on the ratings your stories have received from your colleagues. You earn XP with every action you take. You get 2500 XP for uploading a profile picture, 50 XP for viewing a lesson or story, 100 for commenting on them and 250 for rating. Sharing a story will get you 2500 XP!</p>
                            {/*<p>On the second widget, you will be able to view all earned awards. There will be multiple of those to be earned, some for story creation, some for getting great ratings from your colleagues and others for completing lessons.</p>
                            <p>The third widget provides a glimpse to how many users, lessons and stories are currently on the platform. </p>*/}
                        </Col>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/home1.jpg'/>
                        </Col>
                    </Row>
                    <Row className='lykiocss-margin-top-1em'>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/home2.jpg'/>
                        </Col>
                        <Col xs={6}>
                            <p>On the Home page, you will also find collections of recommended stories and lessons that are calculated specifically for you based on your actions on the platform.</p>
                            <p>You can quickly go through many lessons by sliding sideways. By hovering or long-tapping on a lesson you will get a preview of the lesson's description. Clicking on it will get you to the lesson's overview page.</p>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="units" title={`${categoriesName}`}>
            <Container>
                    <Row>
                        <Col xs={6}>
                            <div className='lykiocss-title-light'>{categoriesName}</div>
                            <p>All available categories can be found by clicking on the <b>{categoriesName}</b> option on the navbar.</p>
                            <p>Categories and their subcategories on the platform are grouped and displayed as a set of sliders like the ones found on the Home page.</p>
                            <p>Users can navigate to their selected lesson to find the lesson's overview page. An example of such a page is displayed in the picture below.</p>
                            <p>On this page you can comment on the lesson, view its description, objective and statistical details as well as add it to your <b><a href="/myplaylists" target="_blank" rel="noopener noreferrer">Favourites</a></b> collection.</p>
                        </Col>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/categories1.jpg'/>
                        </Col>
                    </Row>
                    <Row className='lykiocss-margin-top-1em'>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/categories2.jpg'/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="stories" title={`${storiesName}`}>
                <Container>
                    <Row>
                        <Col xs={6}>
                            <div className='lykiocss-title-light'>{storiesName}</div>
                            <p>On the <b><a href="/stories" target="_blank" rel="noopener noreferrer">{storiesName}</a></b> page, you will find a grid of all stories uploaded by your colleagues</p>
                            <p>Clicking on a story will bring up the modal view. This will help you stay on the same page while viewing and interacting with dozens of your colleagues' stories. </p>
                            <p>Apart from reading, commenting and rating the story, you can also add it to your Favourites collection, the same way you would with a normal lesson.</p>
                            <p>You can also give some em😄ji flair to your comments by going through Lykio's extensive emoji library and picking whatever emoji represents you best.</p>
                        </Col>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/story1.jpg'/>
                        </Col>
                    </Row>

                    <Row className='lykiocss-margin-top-1em'>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/story2.jpg'/>
                        </Col>
                        <Col xs={6}>
                            <p>All users can create stories. To <b><a href="/create" target="_blank" rel="noopener noreferrer">create a story</a></b> you will need to provide at least a title and a media file. </p>
                            <p>You can also add text to your story and format it to your liking. By using the built-in text editor you can add headers, paragraphs and numbered lists as well as move parts of your story up and down.</p>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="leaderboards" title="Leaderboards">
                <Container>
                    <Row>
                        <Col xs={6}>
                            <div className='lykiocss-title-light'>Leaderboards</div>
                            <p>On the <b><a href="/leaderboards" target="_blank" rel="noopener noreferrer">Leaderboards</a></b> page you will find a set of leaderboards for users. Clicking on any user will take you to their page.</p>
                            <p>There are leaderboards based on how many XP users have earned. Leaderboards are divided in global and local variants. In the global leaderboard, you get data about who the leaders are in your organisation while the local leaderboards give you a glimpse of how your team is doing.</p>
                            <p>Similarly to the XP leaderboards, you will also find leaderboards based on how many stories your colleagues have uploaded both locally and globally.</p>
                            <p>Most Impactful users and stories also have their leaderboards. Impact for users is calculated as a product of the user's total of stories and the average rating of these stories. For stories the respective product is that of the unit's average rating and the total number of ratings.</p>
                        </Col>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/leaderboards.jpg'/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {((userRole==='teacher') || userRole==='manager' || (userRole==='admin')) &&
            <Tab eventKey="admin" title="Admin Options">
                <Container>
                {(userRole==='teacher' || userRole==='manager') && <React.Fragment>
                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Reports</div>
                        <p>You can use the <b><a href="/reports" target="_blank" rel="noopener noreferrer">Reports</a></b> feature to get a sense of what your users have been up to. You can select a period and a brief report of platform logins and unit consumption will be generated. You can also export the report as an Excel-compatible file to your device.</p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/08_reporting.png'/>
                        </Col>
                    </Row>


                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Managing users, groups and departments</div>
                        <p>The <b>User Management</b> page gives you access to creating users as well as locking them and changing their role on the platform.</p>
                        <p>The 3 available roles are the following:</p>
                        <p>
                        <ul>
                            <li>Managers can view quick reports about the group they manage and manage all users of that group. They can also upload lessons via all the ways the platform supports.</li>
                            <li>Educators can do all things managers can do apart from accessing the quick reports. Both Educators and Managers can create playlists and assign them to the group to which they belong.</li>
                            <li>Learners can view the platform’s content, upload stories and create private playlists of lessons and stories.</li>
                        </ul>
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/13_user_management.png'/>
                        </Col>
                    </Row>

                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Uploading content</div>
                        <p>Lykio has a built-in webpage maker. As displayed in the first of the three images below you can use the <b><a href="/create-new-content" target="_blank" rel="noopener noreferrer">Create System Content</a></b> page to design your lesson using pages, headers, paragraphs, embedded videos and images.</p>
                        <p>Lykio also supports SCORM and xAPI content. Any such content can be uploaded by using the <b><a href="/add-new-content" target="_blank" rel="noopener noreferrer">Add Cloud Hosted Content</a></b> page shown in the middle picture. To use this option you will have to be hosting it on a server and give to Lykio the links to your home page and cover image (along with all the basic information, title, description etc.). You can also upload it as a zip file by using the <b><a href="/upload-zipped-unit" target="_blank" rel="noopener noreferrer">Upload Zipped Content</a></b> page. The process is similar but this time you will have to give the relative paths of your start page and cover image and Lykio will host your content on its own Cloud Storage.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/24_grapes.png'/>
                        </Col>
                        <Col xs={3}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/14_cloud_hosted.png'/>
                        </Col>
                        <Col xs={3}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/23_zipped_content.png'/>
                        </Col>
                    </Row>
                    </React.Fragment>}
                {(userRole==='admin') && <React.Fragment>
                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Reports</div>
                        <p>You can use the <b><a href="/reports" target="_blank" rel="noopener noreferrer">Reports</a></b> feature to get a sense of what your users have been up to. You can select a period and a brief report of platform logins and unit consumption will be generated. You can also export the report as an Excel compatible file to your device.</p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/08_reporting.png'/>
                        </Col>
                    </Row>

                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Adding Custom Awards</div>
                        <p>By using the <b><a href="/award" target="_blank" rel="noopener noreferrer">Add Award</a></b> page, you can add to the platform your custom award to be earned by your users. You can choose from a preselected set of types (“upload X number of stories”, “View X number of lessons” etc.). You will have to provide your own image file for the badge.</p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/09_add_award.png'/>
                        </Col>
                    </Row>
                    
                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Customizing Lykio for your users</div>
                        <p>On the <b><a href="/customize-lykio" target="_blank" rel="noopener noreferrer">Customise Lykio</a></b> page, you can set up a bunch of settings about how users experience the Lykio platform. You can pick a theme, use different terms for important entities of the platform (e.g. rename the “Stories” feature to “Pride Stories” or the “Categories” option of the navbar to “Ideology Toolkit”)</p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/10_customize_lykio.png'/>
                        </Col>
                    </Row>

                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Adding Categories</div>
                        <p>You can add subcategories and categories from the <b><a href="/manage-categories" target="_blank" rel="noopener noreferrer">Add Categories</a></b> page. You will have to provide a name and some words to describe what the category is all about.</p>
                        <Image fluid style={{width:'20em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/11_add_category.png'/>
                        </Col>
                    </Row>

                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Moderating content</div>
                        <p>The <b><a href="/manage-content/System" target="_blank" rel="noopener noreferrer">Content Management</a></b> page allows you to edit, activate and deactivate units, approve incoming stories and pick which of them will be featured on the Home page.</p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/12_unit_management.png'/>
                        </Col>
                    </Row>

                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Managing users, groups and departments</div>
                        <p>The <b>User Management</b> page gives you access to creating new groups, departments and adding users as well as locking them and changing their role on the platform.</p>
                        <p>The 4 available roles are the following:</p>
                        <p>
                        <ul>
                            <li><b>Admins</b> can view all available options of the platform. They can manage categories, content, users, customise the appearance of the platform and create playlists which they can assign to all existing groups.</li>
                            <li><b>Managers</b> can view quick reports about the group they manage and manage all users of that group. They can also upload lessons via all the ways the platform supports.</li>
                            <li><b>Educators</b> can do all things managers can do apart from accessing the quick reports. Both Educators and Managers can create playlists and assign them to the group to which they belong.</li>
                            <li><b>Learners</b> can view the platform’s content, upload stories and create private playlists of lessons and stories.</li>
                        </ul>
                        </p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/13_user_management.png'/>
                        </Col>
                    </Row>

                    <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Uploading content</div>
                        <p>Lykio has a built-in webpage maker. As displayed in the first of the three images below you can use the <b><a href="/create-new-content" target="_blank" rel="noopener noreferrer">Create System Content</a></b> page to design your lesson using pages, headers, paragraphs, embedded videos and images.</p>
                        <p>Lykio also supports SCORM and xAPI content. Any such content can be uploaded by using the <b><a href="/add-new-content" target="_blank" rel="noopener noreferrer">Add Cloud Hosted Content</a></b> page shown in the middle picture. To use this option you will have to be hosting it on a server and give to Lykio the links to your home page and cover image (along with all the basic information, title, description etc.). You can also upload it as a zip file by using the <b><a href="/upload-zipped-unit" target="_blank" rel="noopener noreferrer">Upload Zipped Content</a></b> page. The process is similar but this time you will have to give the relative paths of your start page and cover image and Lykio will host your content on its own Cloud Storage.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/24_grapes.png'/>
                        </Col>
                        <Col xs={3}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/14_cloud_hosted.png'/>
                        </Col>
                        <Col xs={3}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/guides/23_zipped_content.png'/>
                        </Col>
                    </Row>
                    </React.Fragment>}
                </Container>
            </Tab>}

            <Tab eventKey="play" title="Search and Favourites">
                <p>Search and Favourites are new ways to search for content and store them in collections to view them at a later time.</p>
                <Container>
                <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Search</div>
                        <p>The <b><a href="/search" target="_blank" rel="noopener noreferrer">Search</a></b> page helps you find lessons, stories and users. Any selected result will be displayed right there for you to interact with it. This includes adding any lesson or story you find to your Favourites Collection.</p>
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/search.jpg'/>
                        </Col>
                </Row>

                <Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Favourites</div>
                        <p>On any lesson or story, right over the <i>add comment</i> text field you will find the <i>add to Favourites</i> button. Any lesson or story you choose will be part of your Favourites collection which can be found under <b><a href="/myplaylists" target="_blank" rel="noopener noreferrer">My Favourites</a></b>.</p> {/*Along with your favourites, you will find there all the collections you have created and any collections assigned to you by your manager or administrator.*/}
                        <Image fluid style={{width:'40em'}} src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/favourites.jpg'/>
                        </Col>
                </Row>

                {/*<Row className='lykiocss-margin-top-1em'>
                        <Col>
                        <div className='lykiocss-title-light'>Create your custom collection</div>
                        <p>By navigating to the <b><a href="/playlist" target="_blank" rel="noopener noreferrer">Manage Collections</a></b> page, you can access a collection maker to create a collection with a name of your choice and even set a deadline on it if you wish.</p>
                        {(userRole==='teacher' || userRole==='manager' || userRole==='admin') && 
                        <p>You can assign any collections you create to your users. Assigning a collection will mean that it will show up on their Collections page and your name will show up as the person who assigned it to them.</p>
                        }
                        </Col>
                </Row>*/}
                </Container>


            </Tab>
            <Tab eventKey="settings" title="Profile and Settings">
            <Container>
                    <Row>
                        <Col xs={6}>
                        <div className='lykiocss-title-light'>Profile</div>
                        <p>To access your <b><a href="/profile/me" target="_blank" rel="noopener noreferrer">Profile</a></b> page, you can click on your avatar and then on the <b>My Profile</b> button. On your profile page, you can edit your basic information and change your profile picture. You can view which badges you have earned and see your followers as well as people you follow.</p>
                        <p>You can also see your personal stats, your most recent actions, your latest uploads and favourite lessons.</p>
                        <p>When you access a colleague's profile page, you will see a “Follow” button right under their profile picture. By following colleagues of yours, your <b><a href="/myfeed" target="_blank" rel="noopener noreferrer">Feed</a></b> will be populated with stories uploaded by them.</p>
                        </Col>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/profile.jpg'/>
                        </Col>
                    </Row>


                    <Row className='lykiocss-margin-top-1em'>
                        <Col xs={6}>
                            <Image fluid src='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/digireact/guides/settings.jpg'/>
                        </Col>
                        <Col xs={6}>
                        <div className='lykiocss-title-light'>Settings</div>
                        <p>On your <b><a href="/settings" target="_blank" rel="noopener noreferrer">Settings</a></b> page, you can change the display language of the platform as well as the content language. All lessons displayed in all categories are filtered to match your selection of content language.</p>
                        <p>You can also change your pass, your timezone and choose what emails you will receive.</p>
                        {/*<p>There also options there for you to add and remove widgets on your Home page.</p>*/}
                        </Col>
                    </Row>
                </Container>
            </Tab>   
            </Tabs>
            </Row>
            }

        </Container>
        }
    </div> );
}

export default Welcome;